import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import Route from 'react-router/Route';
import Switch from 'react-router/Switch';
import client from '../data/client';
import store from '../data/store';
import Navbar from '../components/Navbar';
import DropDownMenu from '../components/stateful/DropDown/DropDownMenu';
import Modal from '../components/stateful/Modal';
import '../data/i18n';
import './reset.css';
import './index.css';

const Layout = ({ children }) => (
  <ApolloProvider client={client}>
    <Provider store={store}>
      <div>
        <Switch>
          <Route path="/login" />
          <Route path="/signup" />
          <Route path="/(reset-password|reset-password-post|update-password)" />
          <Route path="/(spaces|explorer|support|profile|settings)" render={() => <Navbar manager />} />
          <Route component={Navbar} />
        </Switch>
        <Helmet
          title="SpaceTranslate: Simple Translation Service at Scale"
          meta={[
            { name: 'description', content: 'Providing developers and businesses an easy service to optimize, deliver and translate all of your languages, from any source, for faster loading websites and apps.' },
            { name: 'keywords', content: 'i18next, json translate, internationalization, i18n, translation service' },
          ]}
        />
        <DropDownMenu />
        <Modal />
        {children()}
        <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,900" rel="stylesheet" />
      </div>
    </Provider>
  </ApolloProvider>
);

Layout.propTypes = {
  children: PropTypes.func,
};

Layout.defaultProps = {
  children: null,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js